import { Link, LinkProps } from 'react-router-dom';
import { Box } from '@mui/material';

// This is to be used in tables, where the row is expected to act as a link to another page.
// It needs to be used instead of the regular TableCell, for compatibility with Safari browsers.
export const GridClickableCell = ({
  to,
  children,
  ...rest
}: {
  to: string;
  children: React.ReactNode;
} & LinkProps) => (
  <Link
    {...rest}
    to={to}
    style={{
      width: '100%',
      height: '100%',
      textDecoration: 'none',
      color: 'inherit',
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'start',
      ...rest.style,
    }}
    onClick={e => {
      e.stopPropagation();
    }}
  >
    <Box
      sx={{
        px: 1,
        pl: 2,
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      {children}
    </Box>
  </Link>
);
